module.exports = __webpack_public_path__ + "static/img/report_logo_esquerda.fa14e12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report_logo_esquerda.png
// module id = 1Yhg
// module chunks = 0